import { render, staticRenderFns } from "./BpDice.vue?vue&type=template&id=65b0f690&"
import script from "./BpDice.vue?vue&type=script&lang=js&"
export * from "./BpDice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports